// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__2xoYW","input":"styles_input__2dPF1","checkmark":"styles_checkmark__FOyYF","text":"styles_text__yL358","forAdept":"styles_forAdept__1Kz4n"};